import { EllipsisText, Flex, Text, type GridColDef } from '@shared/components';
import { formatDateTime } from '@shared/utils';

import { type ExamLocationRow } from '../../types';

export const examCenterLocationColumns: GridColDef<ExamLocationRow>[] = [
  {
    field: 'province',
    headerName: 'จังหวัด',
    width: 144,
    sortable: false,
    renderCell: ({ row }) => {
      return <EllipsisText>{row.province}</EllipsisText>;
    },
  },
  {
    field: 'locationName',
    headerName: 'สถานที่สอบ / อาคาร / ชั้น',
    flex: 1,
    minWidth: 300,
    renderCell: ({ row }) => {
      return (
        <Flex sx={{ flexDirection: 'column' }}>
          <EllipsisText variant='body1Semibold'>{row.locationName}</EllipsisText>
          <EllipsisText>
            อาคาร: {row.buildingName} ชั้น: {row.floor}
          </EllipsisText>
        </Flex>
      );
    },
  },
  {
    field: 'roomName',
    headerName: 'ห้องสอบ',
    flex: 1,
    minWidth: 300,
    sortable: false,
    renderCell: ({ row }) => {
      return (
        <Flex sx={{ flexDirection: 'column' }}>
          <EllipsisText>ห้อง: {row.roomName}</EllipsisText>
          <EllipsisText>เลขที่: {row.roomNumber}</EllipsisText>
        </Flex>
      );
    },
  },
  {
    field: 'approvedAt',
    headerName: 'วันที่อนุมัติสิทธิ์ใช้งาน',
    width: 184,
    sortable: false,
    renderCell: ({ row }) => {
      return <Text>{row.approvedAt ? formatDateTime(row.approvedAt) : '-'}</Text>;
    },
  },
];
